module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLight.woff2?66205bea5b9a18c71b50cd1edbb6423f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLight.woff2
// module id = 1397
// module chunks = 0